import { inject } from '@angular/core'
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router'
import { Store } from '@ngrx/store'
import { fetchSeasons } from '@features/seasons/state/actions/seasons.actions'
import { CallingContext } from '@features/seasons/models/seasons.models'

export const seasonsResolveFn: ResolveFn<boolean> = (route: ActivatedRouteSnapshot) => {
  const callingContext = route.data['callingContext'] as CallingContext

  if (!callingContext) {
    console.error('[seasonsResolveFn] Missing callingContext in route data configuration.')
  }

  inject(Store).dispatch(
    fetchSeasons({
      includeMatchdays: false,
      callingContext
    })
  )

  return true
}
